import z from 'zod';

import { BaseOptionsSchema, type FormSubmitHandler } from './types.ts';

const DataSchema = z.record(z.string(), z.unknown());

const OptionsSchema = BaseOptionsSchema;

type Data = z.infer<typeof DataSchema>;
type Options = z.infer<typeof OptionsSchema>;

function handle(data: Data, options: Options): Promise<string> {
    const { successMessage } = options;

    console.log('form submit', data, options);

    return new Promise<string>((resolve) => {
        setTimeout(() => resolve(successMessage), 2000);
    });
}

export default {
    dataSchema: DataSchema,
    optionsSchema: OptionsSchema,
    handle,
} satisfies FormSubmitHandler<Data, Options>;
